import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "AppVue" }

import { useRoute } from 'vue-router';
import BasicLayout from '@/layouts/BasicLayout.vue';
import Thumbnail from '@/view/thumbnail/ThumbnailPage.vue';
import { computed } from 'vue';
import MarkupPage from '@/view/MarkupView/MarkupPage.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const showBasicLayout = computed(() => !(route.path.startsWith('/user') || route.path === '/' || route.path === '/markup'));

const showThumbnail = computed(() => route.path === '/');
const showMarkupPage = computed(() => route.path === '/markup');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showBasicLayout.value)
      ? (_openBlock(), _createBlock(BasicLayout, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }))
      : (showThumbnail.value)
        ? (_openBlock(), _createBlock(Thumbnail, { key: 1 }))
        : (showMarkupPage.value)
          ? (_openBlock(), _createBlock(MarkupPage, { key: 2 }))
          : (_openBlock(), _createBlock(_component_router_view, { key: 3 }))
  ]))
}
}

})